import React from "react";
import Accordion from "react-bootstrap/Accordion";
import PaginationModified from "../../../data/PaginationModified";
import {
  convertStraight,
  convertThenFormat,
  formatDateTimezon,
} from "../../common-data/Converts";

const ProspectListingsMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          const planStatus = row?.prospect_status
            ?.replace(/ /g, "_")
            ?.toLowerCase();

          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="log-card-top">
                  <div
                    className="profile-name-number"
                    style={{
                      columnGap: "0",
                      height: "auto",
                    }}
                  >
                    <div className="name-number">
                      <h3
                        className="lead-name link"
                        onClick={() =>
                          setModValues((prevs) => ({
                            ...prevs,
                            isModOpen: true,
                            modName: "member_info",
                            rowData: row,
                          }))
                        }
                      >
                        {row?.name || "NA"}
                      </h3>
                      <p className="number underline">{row?.mobile || "NA"}</p>
                      {row?.email ? (
                        <span className="value email semi-bold underline">
                          {row?.email || "NA"}
                        </span>
                      ) : null}
                      <p className="number">{row?.gym_name || ""}</p>
                    </div>
                  </div>
                </div>

                <div className="all-followuo-info-container">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header style={{ padding: "0 10px 10px 10px" }}>
                        Show More
                      </Accordion.Header>

                      <Accordion.Body style={{ padding: "0 10px 10px 10px" }}>
                        <div className="lead-multi-value-cols">
                          <div className="label-value">
                            <span className="label">Trainer Info</span>
                            <span className="value">
                              {" "}
                              {row?.trainer_name || "NA"}
                              <br />
                              <small style={{ textTransform: "lowercase" }}>
                                {row?.trainer_mobile || ""}
                                <br />
                                {row?.trainer_email || ""}
                              </small>
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">prospect status</span>
                            <span
                              className="value"
                              style={{
                                background:
                                  planStatus === "converted"
                                    ? "#379C00"
                                    : "#D90000",
                                color: "#fff",
                                padding: "5px",
                                borderRadius: "4px",
                              }}
                            >
                              {row?.prospect_status || "NA"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">prospect value</span>
                            <span className="value">
                              ₹{row?.prospect_value || 0}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">date added</span>
                            <span className="value">
                              {" "}
                              {row?.date_added
                                ? formatDateTimezon(row.date_added)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">expected closure date</span>
                            <span className="value">
                              {row?.expected_closure_date
                                ? convertStraight(row.expected_closure_date)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">converted date</span>
                            <span className="value">
                              {row?.converted_date
                                ? convertStraight(row.converted_date)
                                : "-"}
                            </span>
                          </div>

                          <div className="label-value">
                            <span className="label">converted value</span>
                            <span className="value">
                              ₹
                              {convertThenFormat(
                                row.prospect_converted_value || 0
                              )}
                            </span>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default ProspectListingsMobile;
